import React, { useState } from 'react'
import { Modal } from 'antd'
import { useSelector } from 'react-redux'
import MaterialList from '../../../../components/MaterialList'
import { useDeepEffect } from '../../../../utils/hooks'
import { isEmpty } from 'lodash'

const BarcodeMaterialModal = (props) => {
  const { visible, onOk, onCancel, materialForm } = props
  const [materialSelected, setMaterialSelected] = useState({})

  useDeepEffect(() => {
    if (!isEmpty(materialForm)) {
      setMaterialSelected(materialForm)
    }
  }, [materialForm])

  const { materials } = useSelector(
    (state) => ({
      materials: state.material.materials
    }),
    []
  )

  function onClickItem(material) {
    if (material.id === materialSelected.materialId) {
      setMaterialSelected({})
    } else {
      setMaterialSelected((prevState) => {
        prevState.materialId = material.id
        prevState.materialName = material.name
        prevState.materialImageUrl = material.image
        return { ...prevState }
      })
    }
  }

  const renderItemActive = (item) => {
    let active = false
    if (materialSelected.materialId === item.id) {
      active = true
    }

    return active
  }

  return (
    <Modal
      title="เลือกวัสดุ"
      visible={visible}
      destroyOnClose
      width={1000}
      onOk={() => onOk(materialSelected)}
      onCancel={() => onCancel()}>
      <MaterialList
        materials={materials}
        renderItemActive={renderItemActive}
        onClickItem={onClickItem}
      />
    </Modal>
  )
}

export default BarcodeMaterialModal



// WEBPACK FOOTER //
// ./src/pages/Brand/BrandProduct/BarcodeMaterialModal/index.js